import TwemojiWrapper from "../../../components/TwemojiWrapper/TwemojiWrapper";
import React from "react";
import KC_Heading2 from "../../../designsystem/typography/KC-Heading/KC_Heading2";

interface Props {
  title: string;
  className?: string;
}

export default function AnalyticsTitle(props: Props) {
  return (
    <div className={`d-flex ${props.className || ""}`}>
      <KC_Heading2
        text={
          <TwemojiWrapper className="twemoji-h2">{props.title}</TwemojiWrapper>
        }
        primary={true}
        className="w-100 d-flex align-items-center justify-content-center justify-content-sm-start gap-xxs twemoji-flex-injector"
      />
    </div>
  );
}
